<template>
  <div id="app">
    <vue-page-transition name="fade-in-down">
      <router-view class="page" />
    </vue-page-transition>
  </div>
</template>

<script>
    export default {
        name: 'App'
    };
    // 禁止手机端扩大和缩小手势
    window.onload = () => {
        document.addEventListener('touchstart', (event) => {
            if (event.touches.length > 1) {
                event.preventDefault();
            }
        });
        document.addEventListener('gesturestart', (event) => {
            event.preventDefault();
        });
    };

</script>
<style lang="scss" scoped>
  #app {
    height: 100%;
    width: 100%;

    .page {
      position: absolute;
      top: 0;
      bottom: 0;
      width: 100%;
      margin: 0 auto;
      -webkit-overflow-scrolling: touch;
      /*overflow-x: hidden;*/
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue